import { useNavigate } from "react-router-dom";

const MonCompte = () => {
  const navigate = useNavigate(); // Hook pour naviguer entre les pages
  return (
    <div className="min-h-screen bg-gray-100">
      {/* Navbar */}
      <nav className="bg-blue-600 text-white flex justify-between items-center px-6 py-4">
        <div className="text-lg font-bold">logo et le nom</div>
        <div className="flex space-x-16">
          <a onClick={() => navigate("/")} className="hover:underline text-lg">Accueil</a>
          <a onClick={() => navigate("/devis")} className="hover:underline text-lg">Devis</a>
          <button className="hover:underline text-lg">Avis</button>
        </div>
        <div className="flex items-center space-x-6">
          <div className="text-center">
            <button className="bg-red-500 px-4 py-2 rounded-md font-bold text-white">
              06 06 06 06 06
            </button>
            <span className="block text-sm mt-1">Assistant client</span>
          </div>
          <div className="flex flex-col items-center">
            <div className="w-10 h-10 bg-gray-300 rounded-full flex items-center justify-center">
              <span className="text-black font-semibold text-lg cursor-pointer">👤</span>
            </div>
            <span className="cursor-pointer hover:underline">Se connecter</span>
          </div>
        </div>
      </nav>

      {/* Contenu principal amélioré */}
      <div className="flex justify-center mt-10">
        <div className="w-full max-w-lg bg-white shadow-lg rounded-lg p-8">
          <h1 className="text-3xl font-bold text-gray-800 mb-6 text-center">Mon Compte</h1>

          <div className="space-y-4">
            <button onClick={() => navigate("/mesreservation")} className="w-full bg-blue-500 text-white py-3 rounded-md text-lg font-semibold hover:bg-blue-600 transition">
              Mes réservations
            </button>

            <button onClick={() => navigate("/paiement")} className="w-full bg-blue-500 text-white py-3 rounded-md text-lg font-semibold hover:bg-blue-600 transition">
              Mes paiements
            </button>

            <button onClick={() => navigate("/manageaccount")} className="w-full bg-blue-500 text-white py-3 rounded-md text-lg font-semibold hover:bg-blue-600 transition">
              Gérer mon compte
            </button>

            <button onClick={() => navigate("/information")} className="w-full bg-blue-500 text-white py-3 rounded-md text-lg font-semibold hover:bg-blue-600 transition">
              Modifier mes informations
            </button>

            <button className="w-full bg-red-500 text-white py-3 rounded-md text-lg font-semibold hover:bg-red-600 transition mt-4">
              Se déconnecter
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MonCompte;

  